const AMWELL_AGENT_SIZE = 80
const AMWELL_AGENT_MARGIN_BOTTOM = 5
const AMWELL_AGENT_MUTE_SIZE = 72

const AMWELL_VIEWS = {
  SCRIPTS: 'scripts'
}

export {
  AMWELL_AGENT_SIZE,
  AMWELL_AGENT_MARGIN_BOTTOM,
  AMWELL_AGENT_MUTE_SIZE,
  AMWELL_VIEWS
}
